import dayjs from 'dayjs';

export const convertDate = (date, _dayjs=false) => {
  const _date = (date instanceof Date) ? date : date.toDate();
  
  return _dayjs ? dayjs(_date) : _date;
};

export const getDayOfWeek = (date) => {
  return ((dayjs(date).day() - 1) + 7) % 7 + 1;
};

export const isDayInPeriod = (day, periodStart, periodEnd) => {
  const start = periodStart <= periodEnd ? dayjs(periodStart) : dayjs(periodEnd);
  const end = periodStart <= periodEnd ? dayjs(periodEnd) : dayjs(periodStart);

  if(end.diff(start, "day") >= 7) return true;

  const startDay = getDayOfWeek(start.toDate()) + 1;
  const endDay = getDayOfWeek(end.toDate()) + 1;

  if(startDay <= endDay){
    return day >= startDay && day <= endDay;
  } else {
    return day >= startDay || day <= endDay;
  }
};

export const getPeriodLabel = (period, date) => {
  if(period === "day") return date.format("DD/MM/YYYY");
  if(period === "year") return date.year().toString();
  if(period === "month") return date.format("MMMM") + " " + date.year();
  if(period === "week") return "Semaine " + date.week() + " - " + date.year();
};

export const convertFirebaseDates = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;

  if (obj.toDate && typeof obj.toDate === 'function') return obj.toDate(); // obj is a Firebase Timestamp

  for (let key in obj) {
    obj[key] = convertFirebaseDates(obj[key]);
  }

  return obj;
};